<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import SelectWithSearch from "../../Common/SelectWithSearch.vue";
import { RAW_MATERIAL_PATH, RG_RECIPE_PATH } from "@/path";
import axios from "axios";
import Swal from "sweetalert2";
// import BEditableTable from 'bootstrap-vue-editable-table';

export default {
  components: {
    Layout,
    PageHeader,
    SelectWithSearch,
  },
  data() {
    return {
      title: "Add Recipe",
      items: [
        {
          text: "Create / Edit",
        },
        {
          text: "Management",
          active: true,
        },
      ],
      form: {
        status: "testing",
      },
      fields: [
        "name",
        "methods_of_cutting",
        "unit_price",
        "indent",
        "uom",
        "total",
        "actions",
      ],
      data: [],
      isUIReady: false,
      cutting: [
        { value: null, text: "Select Category" },
        { value: "Juliene", text: "Juliene" },
        { value: "Fine Chop (Machine)", text: "Fine Chop (Machine)" },
        { value: "Coarse Powder", text: "Coarse Powder" },
        { value: "Purree", text: "Purree" },
        { value: "Cube Cut", text: "Cube Cut" },
        { value: "Slice", text: "Slice" },
        { value: "Powder", text: "Powder" },
        { value: "Crushed", text: "Crushed" },
        { value: "Diced Big", text: "Diced Big" },
        { value: "Diced Small", text: "Diced Small" },
        { value: "Finger Cut/Batons", text: "Finger Cut/Batons" },
        { value: "French Fry Cut", text: "French Fry Cut" },
        { value: "Boil", text: "Boil" },
        { value: "Sliced + Frying", text: "Sliced + Frying" },
        { value: "Grating", text: "Grating" },
      ],
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      version: 1,
      selectedRecipeId: null,
      isEdit: false,
      key: 1,
      deleteKey: 1,
    };
  },
  computed: {
    RAW_MATERIAL_PATH() {
      return RAW_MATERIAL_PATH;
    },
    RG_RECIPE_PATH() {
      return RG_RECIPE_PATH;
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.key += 1;
      },
    },
  },
  methods: {
    setRawMaterial(e, v) {
      if (this.data[v.index].item_id == null) {
        this.data[v.index].item_id = e.id;
      }

      setTimeout(() => {
        this.data[v.index].unit_price = parseFloat(
          e.price_data
            ? e.price_data.uom == "kg"
              ? e.price_data.unit_price * 0.001
              : e.price_data.uom == "ltr"
              ? e.price_data.unit_price / 1000
              : e.price_data.unit_price
            : 0
        ).toFixed(2);
        this.data[v.index].total = parseFloat(
          this.data[v.index].indent * this.data[v.index].unit_price
        ).toFixed(2);
        this.data[v.index].uom_list = ["gm"];
        this.data[v.index].price_data = e.price_data;
        this.key += 1;
      }, 3000);
    },
    updateObj(v, i, field) {
      console.log(field);
      console.log(v);
      console.log(i);
    },
    addData(type) {
      this.data.push({
        type: type,
        item_id: null,
        uom: "gm",
        _rowVariant: type == "raw_material" ? "default" : "primary",
      });
    },
    deleteRow(v) {
      this.data.splice(v.index, 1);
      this.deleteKey++;
    },
    setTotal(row, field) {
      if (field == "total") {
        this.data[row.index].total = parseFloat(
          row.item.indent * row.item.unit_price
        ).toFixed(2);
      } else {
        this.data[row.index].unit_price = parseFloat(
          row.item.indent / row.item.total
        ).toFixed(2);
      }
    },
    async getData() {
      try {
        let res = await axios.get(this.base_url + RG_RECIPE_PATH.SHOW, {
          params: {
            id: this.selectedRecipeId,
          },
        });
        if (res.data.status) {
          let d = res.data.data;
          this.form = {
            recipe_name: d.recipe_name,
            type_of_recipe: d.type_of_recipe,
            batch_size: d.batch_size,
            uom: d.uom,
            cooking_loss: d.cooking_loss,
            approved_cost: d.approved_cost,
            recipe_description: d.description,
            status:
              this.$route.query.production &&
              this.$route.query.production == true
                ? "production"
                : d.status,
            version:
              this.$route.query.production != true ||
              (this.$route.query.production == true && this.isEdit == true)
                ? this.version
                : 1,
            previous_version:
              this.isEdit == true ? d.previous_version : this.selectedRecipeId,
          };
          this.data = d.items.map((f) => {
            let d = {};
            d.item_id = f.recipe_id != null ? f.recipe_id : f.raw_material_id;
            d.type = f.recipe_id != null ? "recipe" : "raw_material";
            d.unit_price = f.unit_price;
            d.cutting_method = f.cutting_method;
            d.indent = f.qty;
            d.total = f.total_price;
            d.uom = f.uom;
            d.uom_list = ["gm"];
            return d;
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      try {
        this.form.items = this.data;
        let res;
        if (this.isEdit == true) {
          this.form.id = this.selectedRecipeId;
          res = await axios.post(
            this.base_url + RG_RECIPE_PATH.UPDATE,
            this.form
          );
        } else {
          res = await axios.post(
            this.base_url + RG_RECIPE_PATH.SAVE,
            this.form
          );
        }
        if (res.data.status) {
          Swal.fire("Recipe Created Successfully", "", "success");
          this.$router.push("/raw_material_to_gravy_recipe");
          return;
        }
        throw new Error(res.data.message);
      } catch (error) {
        console.log(error);
        Swal.fire("Failed to save", "", "error");
      }
    },
    getTotalCost() {
      return this.data.reduce((a, c) => {
        return parseFloat(a) + parseFloat(c.total);
      }, 0);
    },
    getTotalYeild() {
      if (this.form.uom == "kg") {
        return parseFloat(
          this.data.reduce((a, c) => {
            return parseFloat(a) + parseFloat(c.indent);
          }, 0) *
            0.001 -
            (this.form.cooking_loss ?? 0)
        ).toFixed(2);
      } else {
        return Math.round(
          this.data.reduce((a, c) => {
            return parseFloat(a) + parseFloat(c.indent);
          }, 0) - (this.form.cooking_loss ?? 0),
          2
        );
      }
    },
  },
  mounted() {
    if (this.$route.params.recipe_id) {
      this.selectedRecipeId = this.$route.params.recipe_id;
      this.version = this.$route.params.version;
      this.isEdit = this.$route.query.isEdit != undefined ? true : false;
      this.getData();
    }
    this.addData("raw_material");
    this.$nextTick(() => {
      setTimeout(() => {
        this.isUIReady = true;
      }, 1000);
    });
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row class="gy-3">
      <b-col sm="1" style="align-self: end" class="mb-3">
        <router-link to="/raw_material_to_gravy_recipe"
          ><b-button variant="primary" class="px-4 flex items-center">
            Back</b-button
          ></router-link
        >
      </b-col>
      <b-col sm="4" class="mb-3">
        <label>Recipe Name</label>
        <b-input v-model="form.recipe_name"></b-input>
      </b-col>
      <b-col sm="3">
        <label>Recipe Type</label>
        <b-select
          value-field="key"
          text-field="display"
          :options="[
            { key: 'end_product', display: 'End Product' },
            { key: 'semi_finished', display: 'Semi Finised' },
          ]"
          v-model="form.type_of_recipe"
        ></b-select>
      </b-col>
      <b-col sm="3">
        <label>Batch Size</label>
        <b-input v-model="form.batch_size" type="number"></b-input>
      </b-col>
      <b-col sm="2">
        <label>Uom</label>
        <b-select
          value-field="key"
          text-field="display"
          :options="[
            { key: 'kg', display: 'Kgs' },
            { key: 'pcs', display: 'Pcs' },
            { key: 'gm', display: 'Gms' },
          ]"
          v-model="form.uom"
        ></b-select>
      </b-col>
      <b-col sm="4">
        <label>Recipe description</label>
        <b-textarea v-model="form.recipe_description"></b-textarea>
      </b-col>
      <b-col sm="2">
        <label>Cooking Loss ({{ form.uom }})</label>
        <b-input v-model.number="form.cooking_loss"></b-input>
      </b-col>
      <b-col sm="2">
        <label>Recipe Approved Cost</label>
        <b-input v-model.number="form.approved_cost"></b-input>
      </b-col>
    </b-row>
    <b-card>
      <b-card-header sm="6" :key="key">
        <div class="row">
          <div class="col-sm-2">
            <label>Total Cost</label>
            <p>Rs. {{ getTotalCost() }}</p>
          </div>
          <div class="col-sm-2">
            <label>Total Yeild</label>
            <p>{{ getTotalYeild() }} {{ form.uom }}</p>
          </div>
        </div>
      </b-card-header>
      <b-table :items="data" :fields="fields">
        <template v-slot:cell(name)="row">
          <span>
            <SelectWithSearch
              v-if="row.item.type == 'raw_material'"
              :id_required="true"
              :full_object="true"
              :selected_data="[row.item.item_id]"
              selected_by="id"
              :search_api="RAW_MATERIAL_PATH.SEARCH_ITEMS"
              @selectedOption="setRawMaterial($event, row)"
              :key="deleteKey"
              track_by="id"
              display="name"
            ></SelectWithSearch>
            <SelectWithSearch
              v-else
              :search_api="RG_RECIPE_PATH.SEARCH"
              :id_required="true"
              :selected_data="[row.item.item_id]"
              selected_by="id"
              :key="deleteKey"
              @selectedOption="(v) => (row.item.item_id = v)"
              track_by="id"
              display="recipe_name"
            ></SelectWithSearch>
          </span>
        </template>
        <template v-slot:cell(methods_of_cutting)="row">
          <b-form-select
            v-model="row.item.cutting_method"
            :options="cutting"
            :value="row.item.cutting_method"
          ></b-form-select>
        </template>
        <template v-slot:cell(unit_price)="row">
          <b-input
            type="number"
            v-model="row.item.unit_price"
            @input="setTotal(row, 'total')"
          ></b-input>
        </template>
        <template v-slot:cell(uom)="row">
          <b-select
            v-if="row.item.name"
            :options="row.item.uom_list"
            v-model="row.item.uom"
          ></b-select>
          <b-select
            v-else
            :options="[{ value: 'gm', text: 'gm' }]"
            v-model="row.item.uom"
          ></b-select>
        </template>
        <template v-slot:cell(indent)="row">
          <b-input
            type="number"
            v-model="row.item.indent"
            @input="setTotal(row, 'total')"
          ></b-input>
        </template>
        <template v-slot:cell(total)="row">
          <b-input
            type="number"
            v-model="row.item.total"
            @input="setTotal(row, 'unit')"
          ></b-input>
        </template>
        <template v-slot:cell(actions)="row">
          <b-button variant="danger" @click="deleteRow(row)"
            ><i class="fa fa-trash"></i
          ></b-button>
        </template>
      </b-table>
      <b-card-footer>
        <div class="flex justify-content-center text-center">
          <b-button
            variant="default"
            style="width: 50%; font-size: small"
            @click="addData('raw_material')"
            ><i class="fa fa-plus"></i> Add Raw Material</b-button
          >
          <b-button
            variant="default"
            style="width: 50%; font-size: small"
            @click="addData('recipe')"
            ><i class="fa fa-plus"></i> Add Other Recipe</b-button
          >
        </div>
      </b-card-footer>
      <b-button variant="success" style="margin-top: 2%" @click="save"
        >Save</b-button
      >
    </b-card>
  </Layout>
</template>

<style>
table.editable-table {
  margin: auto;
  width: auto;
}

table.editable-table td {
  vertical-align: middle;
  padding: 0;
}

.editable-table .data-cell {
  padding: 8px;
  vertical-align: middle;
}

.editable-table .custom-checkbox {
  width: 50px;
}

.name-col {
  width: 120px;
}

.department-col {
  width: 150px;
}

.age-col {
  width: 100px;
}

.date-col {
  width: 200px;
}

.is-active-col {
  width: 100px;
}
</style>
